import Http from '../Http';

const baseUrl = `${process.env.VAPI_BASE_URL}/thirdpartyproviders`;

export default {
  listProviders: () => Http.post(baseUrl),
  lookupThirdPartyId: (locationId) => Http.post(`${baseUrl}/placekey/lookup/${locationId}`),
};
